import { GridType } from "../GridType";

export class RowMenuItemInfo {
	
	constructor(public ContractId: string, public ResourceId: string, public GridType: GridType, public ProjectId?: string, public Properties: { [key: string]: any; } = {}) { }

	public Start: Date;
	public End: Date;
}